var enumToArray = function (enumValue) {
    return Object.keys(enumValue).map(function (i) { return enumValue[i]; });
};
export default enumToArray;
